<template>
  <b-container class="text-left" fluid style="height: 83vh;overflow: hidden auto;">
    <b-overlay :show="isLoadingDetail" rounded="sm">
      <HeaderComponent :thirdPartyData="thirdPartyData" />
    </b-overlay>
    <b-card class="my-3" no-body>
      <b-overlay :show="isLoadingDetail" rounded="sm">
        <b-tabs small card fill justified>
          <b-tab title="Risk Summary">
            <RiskSummaryTabComponent />
          </b-tab>
          <b-tab
            title="DUE DILIGENCE REMEDIATION & MONITORING"
            :lazy="$store.state.dueDiligenceRemediationMonitoringTabLazyLoad"
          >
            <DueDiligenceRemediationMonitoringTabComponent />
          </b-tab>
          <b-tab
            title="QUESTIONNAIRES, POLICIES, COMMS & TRAINING"
            :lazy="$store.state.questionnairesPoliciesTrainingTTabLazyLoad"
          >
            <QuestionnairesPoliciesTrainingTabComponent />
          </b-tab>
          <b-tab title="DOCUMENTS" :lazy="$store.state.documentsTabLazyLoad">
            <DocumentsTabComponent />
          </b-tab>
          <b-tab title="THIRD PARTY DETAILS & ASSOC.">
            <ThirdPartyDetailsAssocTabComponent :thirdPartyData="thirdPartyData" />
          </b-tab>
          <b-tab title="AUDIT TRAIL" :lazy="$store.state.auditTrailTabLazyLoad">
            <AuditTrailTabComponent />
          </b-tab>
        </b-tabs>
      </b-overlay>
    </b-card>
    <FooterComponent />
  </b-container>
</template>
<script>
import { HTTP } from "../utils/HTTP";
import HeaderComponent from "../components/thirdpartyProfilePageComponents/headerComponent.vue";
import FooterComponent from "../components/thirdpartyProfilePageComponents/footerComponent.vue";
import RiskSummaryTabComponent from "../components/thirdpartyProfilePageComponents/riskSummaryTab/riskSummaryTabComponent.vue";
import DueDiligenceRemediationMonitoringTabComponent from "../components/thirdpartyProfilePageComponents/dueDiligenceRemediation/dueDiligenceRemediationMonitoringTabComponent.vue";
import QuestionnairesPoliciesTrainingTabComponent from "../components/thirdpartyProfilePageComponents/questionnairesPoliciesTraining/questionnairesPoliciesTrainingTabComponent.vue";
import DocumentsTabComponent from "../components/thirdpartyProfilePageComponents/documentsTab/documentsTabComponent.vue";
import ThirdPartyDetailsAssocTabComponent from "../components/thirdpartyProfilePageComponents/thirdPartyDetailsAssoc/thirdPartyDetailsAssocTabComponent.vue";
import AuditTrailTabComponent from "../components/thirdpartyProfilePageComponents/auditTrailTab/auditTrailTabComponent.vue";
export default {
  name: "ThirdPartyEntityPage",
  components: {
    HeaderComponent,
    FooterComponent,
    RiskSummaryTabComponent,
    DueDiligenceRemediationMonitoringTabComponent,
    QuestionnairesPoliciesTrainingTabComponent,
    DocumentsTabComponent,
    ThirdPartyDetailsAssocTabComponent,
    AuditTrailTabComponent
  },
  data() {
    return {
      isLoadingDetail: false,
      thirdPartyData: null
    };
  },
  computed: {},
  mounted() {
    this.$store.state.dueDiligenceRemediationMonitoringTabLazyLoad = true;
    this.$store.state.questionnairesPoliciesTrainingTTabLazyLoad = true;
    this.$store.state.documentsTabLazyLoad = true;
    this.$store.state.auditTrailTabLazyLoad = true;
    this.getThirdPartyDetail();
  },
  methods: {
    async getThirdPartyDetail() {
      this.companyId = null;
      this.thirdPartyData = null;
      let formData = {
        thirdPartyId: this.$route.params.thirdPartyId
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.isLoadingDetail = true;
        let result = await HTTP("post", "thirdparty/detail", formData, {
          Authorization: token
        });
        if (result && result.data.status == 1 && result.status == 200) {
          this.thirdPartyData = result.data.response;
          this.isLoadingDetail = false;
        } else {
          this.thirdPartyData = null;
          this.isLoadingDetail = false;
        }
      } catch (error) {
        this.isLoadingDetail = false;
      }
    }
  }
  //   props: {
  //     thirdPartyIdProp: Number
  //   }
};
</script>